export const Categories = axios => ({
  list () {
    return axios.get('/v1/categories')
  },

  all () {
    return axios.get('/v1/categories/all')
  },

  tree () {
    return axios.get('/v1/categories/tree')
  }
})
